export const statesAbbreviationList = [
  { label: "ANDAMAN AND NICOBAR ISLANDS", value: "AN" },
  { label: "ANDHRA PRADESH", value: "AP" },
  { label: "ARUNACHAL PRADESH", value: "AR" },
  { label: "ASSAM", value: "AS" },
  { label: "BIHAR", value: "BR" },
  { label: "CHANDIGARH", value: "CH" },
  { label: "CHATTISGARH", value: "CG" },
  { label: "DAMAN & DIU", value: "DD" },
  { label: "DADRA & NAGAR HAVELI", value: "DN" },
  { label: "DELHI", value: "DL" },
  { label: "GOA", value: "GA" },
  { label: "GUJARAT", value: "GJ" },
  { label: "HARYANA", value: "HR" },
  { label: "HIMACHAL PRADESH", value: "HP" },
  { label: "JAMMU & KASHMIR", value: "JK" },
  { label: "JHARKHAND", value: "JH" },
  { label: "KARNATAKA", value: "KA" },
  { label: "KERALA", value: "KL" },
  { label: "LADAKH", value: "LA" },
  { label: "LAKSHADWEEP", value: "LD" },
  { label: "MANIPUR", value: "MN" },
  { label: "MAHARASHTRA", value: "MH" },
  { label: "MEGHALAYA", value: "ML" },
  { label: "MIZORAM", value: "MZ" },
  { label: "MADHYA PRADESH", value: "MP" },
  { label: "NAGALAND", value: "NL" },
  { label: "ORISSA", value: "OR" },   
  { label: "PONDICHERRY", value: "PY" }, 
  { label: "PUNJAB", value: "PB" },
  { label: "RAJASTHAN", value: "RJ" },
  { label: "SIKKIM", value: "SK" },
  { label: "TAMIL NADU", value: "TN" },
  { label: "TELANGANA", value: "TG" }, 
  { label: "TRIPURA", value: "TR" },
  { label: "UTTAR PRADESH", value: "UP" },
  { label: "UTTARANCHAL", value: "UA" }, 
  { label: "WEST BENGAL", value: "WB" },
  { label: "APO Address", value: "APO" }, 
];
